import React, { useState, useEffect } from "react";
import "./ViewClasse.scss";
import Button from "../../controls/buttons/Button";
import arrowLeft from '../../../assets/arrowLeft.png';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ReactPlayer from 'react-player'
import DownloadIcon from '@mui/icons-material/Download';

const AntTabs = withStyles({
    root: {
        borderBottom: '0.5px solid #C7C7C7',
    },
    indicator: {
        backgroundColor: '#071FC1',
    },
})(Tabs);

const AntTab = withStyles(theme => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(4),
        fontSize: '22px',
        fontFamily: 'Open Sans',

        '&:hover': {
            color: '#071FC1',
            opacity: 1,
            fontWeight: theme.typography.fontWeightRegular,
        },
        '&$selected': {
            color: '#071FC1',
            fontWeight: theme.typography.fontWeightBold,
        },
    },
    selected: {},
}))(props => <Tab disableRipple {...props} />);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
    tabsHeader: {
        backgroundColor: theme.palette.background.paper,
    }
}));


function ViewClasse({ goBack, aula, index, modName }) {

    const [tabValue, setTabValue] = useState(0);
    const classes = useStyles();


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])



    function getClassDate() {
        let d = new Date(aula.classDate);
        return (d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear())
    }

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    function formatFileSize(bytes, decimalPoint) {
        if (bytes == 0) return '0 Bytes';
        var k = 1000,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    function downloadFile(link, name) {
        try {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function (event) {
                //Create an `a` tag (since it has an `href` and a `download` attribute) 
                var a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhr.response);
                a.download = name;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();                            //Simulates a click event
                var blob = xhr.response;
            };
            xhr.open('GET', link);
            xhr.send();

        }
        catch (errors) {
            console.log(errors);
        }
    }

    function renderFiles() {
        let array = aula.classFiles;
        let files = [];
        array.forEach(el => {
            if (el.link) {
                files.push(
                    <div className="file-div-classe">
                        <div className="file-div-classe-left">
                            <label> {el.name}</label>
                        </div>
                        <div className="file-div-classe-right">
                            <label>{formatFileSize(el.size)}</label>
                            <DownloadIcon onClick={() => downloadFile(el.link, el.name)} />
                        </div>
                    </div>
                )
            }
            
            else{
                files.push(
                    <div className="file-div">
                        <div className="file-div-left">
                            <label> {el.name}</label>
                        </div>
                        <div className="file-div-right">
                            <label>{formatFileSize(el.size)}</label>
                        </div>
                    </div>
                )
            }

        });
        return files;
    }

    function validateURL(link) {
        if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
            return (link)
        }
        else {
            return ("https://" + link)
        }
    }

    function renderLinks() {
        let array = aula.classContent;
        let files = [];
        array.forEach(el => {
            if (el.link) {
                files.push(
                    <div className="file-div-classe">
                        <div className="file-div-classe-left">
                            <a href={validateURL(el)} target="_blank" rel="noreferrer noopener">
                                {el}
                            </a>
                        </div>
                    </div>
                )
            }

        });
        return files;
    }

    return (
        <div className="view-classe-container">
            <div className="view-classe-video">
                <div className="player-wrapper">
                    <ReactPlayer
                        className='react-player'
                        url={validateURL(aula.classLink)}
                        controls
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
            <div className="view-classe-main">
                <div className="view-classe-header" style={{ cursor: 'pointer' }} onClick={(e) => goBack()}>
                    <img src={arrowLeft} style={{ height: '18px' }}></img>
                    <span className="classe-view-subjects" >Aula {index}: {aula.name}</span>
                </div>

                <div className="Class-name-field">
                    <label
                        className="Class-subtitle-view"
                    >
                        Aula {aula.classType == "Assíncrona" ? "Assíncrona" : "Síncrona - " + getClassDate() + " - " + aula.classTime}
                    </label>
                </div>
                <div className="Class-name-field">
                    <label
                        className="Class-subtitle-view"
                    >
                        Módulo: {modName}
                    </label>
                </div>
                <div>

                    <div className="classe-files">
                        <span className="classe-view-subjects" >Link da aula</span>
                    </div>
                    <div className="file-div-classe">
                        <div className="file-div-classe-left">
                            <a href={validateURL(aula.classLink)} target="_blank" rel="noreferrer noopener">
                                {aula.classLink}
                            </a>
                        </div>
                    </div>
                    <div className="classe-files">
                        <span className="classe-view-subjects" >Descrição</span>
                    </div>
                    {aula.classDesc && <div className="file-div-classe">
                        <div className="file-div-classe-left">
                            <label className="Subject-description-view">
                                {aula.classDesc}
                            </label>
                        </div>
                    </div>}
                    {aula.classFiles.length > 0 && <div className="classe-files">
                        <span className="classe-view-subjects" >Arquivos</span>
                    </div>}
                    {renderFiles()}

                    {aula.classContent.length > 0 && <div className="classe-files">
                        <span className="classe-view-subjects" >Links</span>
                    </div>}
                    {renderLinks()}
                </div>


            </div>
        </div>


    );
}

export default ViewClasse;
